import { render, staticRenderFns } from "./product-data.vue?vue&type=template&id=25e8dbc6&"
import script from "./product-data.vue?vue&type=script&lang=js&"
export * from "./product-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports